/** * ステイタスコンポーネント */
<template>
  <b-container id="the-status" class="container-status">
    <!-- 検索ツールバー -->
    <div class="tool-bar">
      <b-form-row class="tool-bar-form">
        <!-- ユーザー選択 -->
        <b-col>
          <user-selector
            v-bind:defaultText="$t('theStatus.allUsers')"
            v-bind:keywordTarget="
              $store.getters['userKeywordTarget/keywordTargets']
            "
            v-bind:onApiError="handleApiError"
            v-bind:indoorSites="$store.getters['indoorSite/indoorSites']"
            v-on:change:value="$_fixSelectedUsers"
            v-on:change:keywordTarget="
              $store.dispatch('userKeywordTarget/setKeywordTargets', $event)
            "
          ></user-selector>
        </b-col>
        <!-- ステイタス選択 -->
        <b-col>
          <status-type-selector
            v-bind:selectType="1"
            v-bind:selectedAllStatusLabel="$t('theStatus.allStatuses')"
            v-on:selectend-status-types="$_onSelectedStatus"
          ></status-type-selector>
        </b-col>
        <!-- 検索期間 -->
        <b-col>
          <datetime-selector
            v-bind:fieldLabel="$t('theStatus.registrationDate')"
            v-bind:periodString="null"
            v-bind:periodFlg="true"
            v-on:datetime-selectend="$_changeSearchPeriod"
          ></datetime-selector>
        </b-col>
        <!-- キーワード検索 -->
        <b-col>
          <input-keyword
            v-model="searchKeyword"
            v-bind:placeholder="$t('theStatus.placeholder.searchKeyword')"
            v-on:search="$_onSearchKeyword"
          />
        </b-col>
      </b-form-row>
    </div>
    <b-row no-gutters class="content-wrapper">
      <!-- ステイタス一覧 -->
      <b-col cols="4" class="view-list" v-show="isListViewShown">
        <!-- タイトルバー -->
        <b-row class="title-bar">
          <b-col class="title-bar-between title-bar-list">
            <h1>
              <!-- ステイタス件数 -->
              {{ $tc('theStatus.numberOfStatus', statusTotalCount) }}
            </h1>
            <div class="title-bar-action">
              <!-- 更新 -->
              <div class="title-bar-reload">
                <div class="label" v-show="listUpdatedDateLabel">
                  {{ $t('theStatus.listUpdate.field') }} :
                  {{ listUpdatedDateLabel }}
                </div>
                <button-reload v-on:click="$_onClickReload" />
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- 一覧 -->
        <div class="list-wrapper">
          <loading-mask v-bind:isLoading="isLoading">
            <!-- ヘッダー -->
            <div class="list-header" />
            <recycle-scroller
              ref="status-list-inner"
              class="list-inner"
              v-bind:items="statusesForCard"
              v-bind:item-size="230"
              v-slot="{ item }"
            >
              <div class="status-detail-content">
                <card-status
                  v-bind="item"
                  v-on:statuscard-click="$_onClickCardBody"
                  v-on:statuscard-title-click="$_onClickCardTitle"
                />
              </div>
            </recycle-scroller>
            <!-- 一覧フッター -->
            <b-row class="list-footer">
              <!-- 表示件数 -->
              <b-col cols="3" class="list-limit">
                <b-form-select
                  size="sm"
                  v-bind:options="listLimitSelectValues"
                  v-bind:value="listLimit"
                  v-on:change="$_onChangeListLimit"
                ></b-form-select>
              </b-col>
              <!-- ページネーション -->
              <b-col cols="6">
                <b-pagination
                  v-model="currentStatusPage"
                  v-bind:total-rows="statusTotalCount"
                  v-bind:per-page="listLimit"
                  align="center"
                  size="sm"
                  class="status-pagination"
                ></b-pagination>
              </b-col>
              <b-col cols="3"></b-col>
            </b-row>
          </loading-mask>
        </div>
      </b-col>
      <!-- 地図 -->
      <b-col v-bind:cols="viewCols.right" class="view-map">
        <map-control
          ref="map-control"
          id="status-map-control"
          v-bind="$store.getters.mapControlBinds"
          v-bind:id-prefix="'status-'"
          v-bind:reactive-render="!isModalOverlaid"
          v-bind:bounds="bounds"
          v-bind:layer-renderers="renderers"
          v-bind:layer-menu-data="layerMenuData"
          v-bind:onIfieldApiError="handleApiError"
          v-on:indoor-level-selected="setActiveIndoorLevelId"
          v-on:map-control-initend="$_onMapInitEnd"
          v-on:menu-layers-visible-changed="$_onLayerMenuVisibleChanged"
        >
          <template v-slot:default="{ currentMapComponent, zoom, center }">
            <template v-for="cluster in clusters">
              <map-popup
                v-if="cluster.fixPopup || cluster.showPopup"
                v-bind:key="`${cluster.id}-status-cluster-popup`"
                v-bind:id-prefix="'status'"
                v-bind:current-map-component="currentMapComponent"
                v-bind:map-center="center"
                v-bind:map-zoom="zoom"
                v-bind:coordinates="cluster.geometry.coordinates"
                v-bind:data="cluster"
                v-bind:offset="popup.offset"
                v-bind:placement="popup.placement"
                v-on:shown="popup.id = $event"
                v-on:hidden="popup.id = null"
                v-on:popup-mouseenter="onPopupMouseEnter"
                v-on:popup-mouseleave="onPopupMouseLeave"
              >
                <template v-slot:default="{ data }">
                  <map-popup-content-status
                    v-bind:data="data.properties.children"
                    v-bind:sort-key="'status_update_at'"
                    v-bind:sort-direction="'desc'"
                    v-on:detail-click="$_showStatusDialog"
                  />
                </template>
              </map-popup>
            </template>
          </template>
          <template v-slot:map-left-top>
            <!-- ビル表示ボタン -->
            <map-indoor-building-button
              v-bind:indoor-building="
                $store.getters['mapIndoor/activeIndoorBuilding']
              "
              class="map-control-ui"
              v-on:reset-click="unselectedBuilding"
            />
            <!-- リスト切り替えタブ -->
            <list-view-toggle-tab
              v-model="isListViewShown"
              v-bind:listViewCols="viewCols.left"
              v-bind:idPrefix="'status'"
              class="map-control-ui list-tab"
              v-on:listview-toggletab-toggled="$_toggleListViewShown"
            />
          </template>
        </map-control>
      </b-col>
    </b-row>
    <status-detail ref="status-detail" />
    <place-detail
      ref="place-detail"
      v-on:place-searchreport-click="$_showReport"
      v-on:place-searchuser-click="$_showMember"
      v-on:hide-modal="$_onHidePlaceDetail"
    />
    <!-- モーダル重畳検知 -->
    <modal-overlay-detector
      v-on:is-modal-overlaid-changed="$_onModalOverlayChanged"
    />
  </b-container>
</template>

<script>
import StatusTypeSelector from '@/components/AppStatusTypeSelector.vue'
import ButtonReload from '@/components/AppButtonReload.vue'
import CardStatus from '@/components/status/AppCardStatus.vue'
import ListViewToggleTab from '@/components/AppListViewToggleTab.vue'
import StatusDetail from '@/views/TheStatusDetail.vue'
import PlaceDetail from '@/views/ThePlaceDetail.vue'
import BvModalOverlayDetector from '@/components/AppBvModalOverlayDetector.vue'
import { RestApiClient, TAG_USER_ROLE_ID } from 'ifield-core-components'
import { MapPopup } from 'ifield-core-components'
import { MapIndoorBuildingButton } from 'ifield-core-components'
import MapPopupContentStatus from '@/components/status/AppMapPopupContentStatus.vue'
import DomainRenderer from '@/js/map-renderer/DomainRenderer.js'
import GeometryUtil from '@/js/util/GeometryUtil.js'
import { toLocalTz, toServerTz } from '@/js/TimezoneHelper'
import {
  DATE_FORMAT_HYPHEN,
  TIME_FORMAT_MILLISECOND,
  CLUSTER_ICON_ID,
  CLUSTERING_MAP_ID,
  CLUSTER_ICON_TEXT_COLOR,
} from '@/constants.js'
import VARIABLES from '@/assets/scss/variables.module.scss'
import _ from 'lodash'
import moment from 'moment'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { shallowRef, inject } from 'vue'
import { mapState, mapGetters } from 'vuex'
import { useHandleApiError } from '@/composables/UseHandleApiError.js'
import { useMapIndoorStore } from '@/composables/map/UseMapIndoorStore'
import { useClusterPopup } from '@/composables/map/UseClusterPopup.js'
import { countUsersByType } from '@/js/util/clusterUtil'
import ModalUtil from '@/js/util/ModalUtil.js'

// レイヤーID
const LAYER_ID = 'status'

// レンダラーファクトリ
const rendererFactory = new DomainRenderer({ layerId: LAYER_ID })

/**
 * ミリ秒日時フォーマット
 */
const DATETIME_FORMAT_MILLISECOND = `${DATE_FORMAT_HYPHEN}T${TIME_FORMAT_MILLISECOND}`

export default {
  name: 'TheStatus',
  components: {
    'button-reload': ButtonReload,
    'card-status': CardStatus,
    'status-type-selector': StatusTypeSelector,
    'map-popup': MapPopup,
    'map-popup-content-status': MapPopupContentStatus,
    'map-indoor-building-button': MapIndoorBuildingButton,
    'list-view-toggle-tab': ListViewToggleTab,
    'status-detail': StatusDetail,
    'place-detail': PlaceDetail,
    'recycle-scroller': RecycleScroller,
    'modal-overlay-detector': BvModalOverlayDetector,
  },
  props: {},
  setup(props, context) {
    /**
     * AppMapControlのインスタンス
     */
    const map = shallowRef(null)

    const { handleApiError } = useHandleApiError(props, context)
    const { unselectedBuilding, setActiveIndoorLevelId } = useMapIndoorStore()
    const {
      popup,
      isClusterHoverd,
      isPopupHoverd,
      clusters,
      hoveredCluster,
      isCluster,
      onClickCluster,
      onHoverCluster,
      onPopupMouseEnter,
      onPopupMouseLeave,
      areClustersEqual,
      getFixPopupFromCurrentClusterInfo,
    } = useClusterPopup()
    const baseDate = inject('baseDate')
    return {
      map,
      handleApiError,
      unselectedBuilding,
      setActiveIndoorLevelId,
      popup,
      isClusterHoverd,
      isPopupHoverd,
      clusters,
      hoveredCluster,
      isCluster,
      onClickCluster,
      onHoverCluster,
      onPopupMouseEnter,
      onPopupMouseLeave,
      areClustersEqual,
      getFixPopupFromCurrentClusterInfo,
      baseDate,
    }
  },
  data: function () {
    return {
      /**
       * ページが表示されている場合はtrue
       * keep-alive で保持されるため、非表示でも破棄されない
       * @type {Boolean}
       */
      isViewActive: true,
      /**
       * 検索条件に一致したステイタス一覧
       * @type {Array}
       */
      statuses: [],
      /**
       * 検索条件に一致したステイタスの全データ件数
       * @type {number}
       */
      statusTotalCount: null,
      /**
       * 選択中のステイタスタイプIDリスト
       * @type {Array<number>}
       */
      currentStatusTypeIds: [],
      /**
       * 選択中の対象ユーザーIDリスト
       * @type {Array<number>}
       */
      currentUserIds: [],
      /**
       * 選択中の対象グループIDリスト
       * @type {Array<number>}
       */
      currentOrganizationIds: [],
      /**
       * 現在選択している検索期間
       */
      searchPeriod: {
        /** 開始日 */
        startDate: null,
        /** 終了日 */
        endDate: null,
      },
      /**
       * 検索キーワード
       * @type {string}
       */
      searchKeyword: null,
      /**
       * 比較用検索キーワード
       * @type {string}
       */
      previousKeyword: '',
      /**
       * 現在選択しているステイタス一覧のページ番号
       * @type {number}
       */
      currentStatusPage: 1,
      /**
       * リストビューを表示する場合true
       * @type {Boolean}
       */
      isListViewShown: true,
      /**
       * 一覧表示の最終更新日時
       * @type {Date}
       */
      listUpdatedDate: null,
      /**
       * ロード中の場合はtrue
       * @type {Boolean}
       */
      isLoading: false,
      /**
       * モーダルが重畳している場合はtrue
       * @type {Boolean}
       */
      isModalOverlaid: false,
      /**
       * 一覧の1ページあたりの表示件数
       * @type {number}
       */
      listLimit: this.$store.state.status.listLimit.value,
      /**
       * レイヤー表示状態
       * @type {Boolean}
       */
      visible: true,
      /**
       * 自データのレイヤーレンダラー
       * @type {Object}
       */
      myRenderer: null,
      // リロード中フラグ
      isReloading: false,
    }
  },
  computed: {
    ...mapGetters('mapLayer', ['clickedPlace']),
    ...mapState('map', ['zoom']),
    ...mapState('userMarker', ['iconAtlas', 'iconMapping']),
    ...mapState({
      /**
       * 一覧の1ページあたりの表示件数の選択リスト値
       * @type {Array<number>}
       */
      listLimitSelectValues: (state) => state.status.listLimit.selectValues,
    }),
    /**
     * クラスタリング実行フラグ
     * @type {Boolean}
     */
    enableClustering: function () {
      return this.$store.getters.isClusteringEnabled(CLUSTERING_MAP_ID.STATUS)
    },
    /**
     * 報告書カード用データ
     * @type {Array.<Object>}
     */
    statusesForCard: function () {
      return this.statuses.map((status) => ({
        id: status.id,
        userId: status.user_id,
        userName: status.user_name,
        profileImageAttachFileType: status.profile_image
          ? status.profile_image.attach_file_type
          : null,
        updateAt: status.status_update_at,
        comment: status.comment,
        statusName: status.status_name,
        statusTypeColor: status.status_type_color,
        baseDate: this.baseDate,
        groups:
          this.$store.getters['user/getUserById'](status.user_id)?.groups || [],
      }))
    },
    /**
     * 地図binding用render関数配列
     * @type {Array.<Function>}
     */
    renderers: function () {
      const renderers = [...this.$store.getters['map/layerRenderers']]
      if (this.myRenderer) {
        renderers.push(this.myRenderer.render)
      }
      return renderers
    },
    /**
     * レイヤーメニュー用データ
     * @type {Array.<Object>}
     */
    layerMenuData: function () {
      const data = [...this.$store.getters['map/layerMenu/layerMenuData']]
      if (this.myRenderer) {
        data.unshift({
          id: this.myRenderer.id,
          name: this.$t('theStatus.layer.status'),
          visible: this.visible,
          geometryTypes: ['Point'],
          color: VARIABLES.ENTITY_COLOR_ORANGE_RED,
        })
      }
      return data
    },
    /**
     * statusのbounds
     * @type {Object}
     */
    bounds: function () {
      if (!this.statuses.length) return null
      return GeometryUtil.getBounds(this.statuses.map((c) => c.geom)).toObject()
    },
    /**
     * ビュー分割のcol数
     */
    viewCols: function () {
      return this.isListViewShown
        ? { left: 4, right: 8 }
        : { left: 0, right: 12 }
    },
    /**
     * 表示用の一覧の最終更新日
     * @type {string}
     */
    listUpdatedDateLabel: function () {
      if (!this.listUpdatedDate) {
        return ''
      }
      return moment(this.listUpdatedDate).format(
        this.$t('theStatus.listUpdate.format')
      )
    },
    /**
     * キーワードが変更された場合はtrue
     * @type {Boolean}
     */
    isKeywordChanged: function () {
      return this.searchKeyword != this.previousKeyword
    },
  },
  created: function () {
    this.$_updateMapLayers()
    this.$_updateIndoorSites()
  },
  mounted: function () {
    this.$_showStatus()
    this.$log.debug('theStatus mounted.')
  },
  activated: function () {
    // 初回描画時は created / mounted で初期化済みなので何もしない
    if (this.isViewActive) return
    this.$log.debug('theStatus activated.')
    this.isViewActive = true
    this.$_showStatus()
  },
  deactivated: function () {
    this.$log.debug('theStatus deactivated.')
    this.isViewActive = false
    // 開いたままのダイアログを閉じる
    ModalUtil.hideAllIn(this)
  },
  watch: {
    statuses: function () {
      this.$_updatePinImage(this.isReloading)
        .then(() =>
          this.$store.dispatch('userMarker/updateTexture', this.isReloading)
        )
        .then(() => {
          this.$_updateStatusLayer()
          this.isReloading = false
        })
    },
    currentStatusPage: function () {
      this.$_showStatus()
    },
    zoom: function () {
      // レイヤー更新
      this.statuses.length && this.$_updateStatusLayer()
    },
    visible: function () {
      this.$_updateStatusLayer()
    },
    enableClustering: function () {
      this.$_updateStatusLayer()
    },
    iconAtlas: function () {
      this.$_updateStatusLayer()
    },
    clickedPlace(value) {
      // Click された Feature が変更された
      // プレイス詳細ダイアログを表示する
      this.$log.debug('[clickedPlace] ', value)
      // 保持されている非表示のページでも watcher は動くので、表示中のページだけが開く
      if (value && this.isViewActive && !this.isModalOverlaid) {
        this.$_showPlaceDialog(value.properties.place_id)
      }
    },
  },
  methods: {
    /**
     * マップレイヤー更新
     */
    $_updateMapLayers: async function () {
      try {
        await this.$store.dispatch('mapLayer/updateMapLayersWithThrottle')
      } catch (error) {
        this.handleApiError(error, () =>
          this.$log.warn('failed to fetch maplayers. use fetched before.')
        )
      }
    },

    /**
     * サイトデータ更新
     */
    $_updateIndoorSites: async function () {
      try {
        this.$store.dispatch('indoorSite/updateIndoorSitesWithThrottle')
      } catch (error) {
        this.handleApiError(error, () => {
          this.$log.info('failed to fetch indoor sites. use fetched before.')
        })
      }
    },

    /**
     * ベースマップ初期化完了時処理
     */
    $_onMapInitEnd: function () {
      this.map = this.$refs['map-control']
    },

    /**
     * レイヤーの表示状態変更イベントの処理
     * @param {Array.<Object>} value 表示状態変更値
     */
    $_onLayerMenuVisibleChanged: function (value) {
      for (const { id, visible } of value) {
        if (id === LAYER_ID) {
          this.visible = visible
        }
      }
      this.$store.dispatch('map/setVisible', value)
    },

    /**
     * ステイタスデータを表示する
     */
    $_showStatus: function () {
      this.$_showStatusList()
      this.$_showStatusTotalCount()
    },

    /**
     * ステイタス一覧を表示する
     */
    $_showStatusList: async function () {
      this.$_showLoading()
      // URL作成
      var url = RestApiClient.createApiUrl('status')
      var params = url.searchParams
      // 検索条件追加
      this.$_addSearchCondition(params)
      // limit, offset
      params.append('limit', this.listLimit)
      var offset = (this.currentStatusPage - 1) * this.listLimit
      if (offset >= 1) {
        // offsetに0を設定するとAPIエラーになってしまうため、1以上の場合のみ設定する
        params.append('offset', offset)
      }

      try {
        const json = await RestApiClient.executeGetApi(url)
        this.statuses = json.data.map((d) => ({
          ...d,
          status_update_at: toLocalTz(d.status_update_at),
        }))
      } catch (error) {
        this.handleApiError(error)
        this.$_hideLoading()
        return
      }

      // 変更検知用に前回キーワードを保持
      this.previousKeyword = this.searchKeyword
      // 一覧のスクロールバーを先頭に戻す
      this.$_scrollListToTop()
      // 更新日を更新する
      this.listUpdatedDate = Date.now()

      this.$_hideLoading()
    },

    /**
     * 地図上に表示するピン画像データを更新
     * @param {Boolean} force 強制更新する場合はtrue
     */
    $_updatePinImage: async function (force) {
      const userIds = [...new Set(this.statuses.map((d) => d.user_id))]
      const promises = userIds.map((id) =>
        this.$store
          .dispatch('userMarker/getImageById', { id, force })
          .catch((error) =>
            this.handleApiError(error, () =>
              this.$log.warn(`failed to update pin image of user ID ${id}.`)
            )
          )
      )
      await Promise.allSettled(promises)
    },

    /**
     * ステイタスレイヤー更新
     * @param {Boolean} force 再描画を強制する場合は true
     */
    $_updateStatusLayer: function (force = false) {
      const props = {
        clustering: this.enableClustering,
        iconAtlas: this.iconAtlas,
        iconMapping: this.iconMapping,
        visible: this.visible,
        zoom: this.zoom,
        getIcon: (d) => {
          if (d.properties.cluster) {
            const cluster = this.clusters.find((cluster) =>
              this.areClustersEqual(d, cluster)
            )
            const isFixed = !!cluster?.fixPopup

            // childrenが存在しない、または空の場合はデフォルトを返す
            if (!d.properties.children?.length) {
              return isFixed
                ? CLUSTER_ICON_ID.SELECTED
                : CLUSTER_ICON_ID.DEFAULT
            }

            const userType = d.properties.user_type
            if (userType) {
              // 動的にキーを生成して出し分ける
              const typePrefix = `${userType.toUpperCase()}`
              const stateSuffix = isFixed ? '_SELECTED' : '_DEFAULT'
              const dynamicKey = `${typePrefix}${stateSuffix}`
              if (CLUSTER_ICON_ID[dynamicKey])
                return CLUSTER_ICON_ID[dynamicKey]
            }
            // フォールバック
            return isFixed ? CLUSTER_ICON_ID.SELECTED : CLUSTER_ICON_ID.DEFAULT
          }

          // ユーザー個別マーカー
          if (this.iconMapping[`${d.properties.user_id}`]) {
            return `${d.properties.user_id}`
          }

          // アプリ/タグユーザーのデフォルトマーカー
          return d.properties.role_id === TAG_USER_ROLE_ID ? 'tag' : 'default'
        },
        getTextColor: (d) => {
          if (d.properties.cluster) {
            const cluster = this.clusters.find((cluster) =>
              this.areClustersEqual(d, cluster)
            )
            return cluster?.fixPopup
              ? CLUSTER_ICON_TEXT_COLOR.SELECTED
              : CLUSTER_ICON_TEXT_COLOR.DEFAULT
          }
        },
        getText: (d) => {
          if (d.properties.cluster) {
            const children = d.properties.children
            if (!children || children.length === 0) {
              return d.properties.point_count
            }
            const { appUsers, tagUsers } = countUsersByType(children)
            if (appUsers > 0 && tagUsers > 0) {
              return `${appUsers}\n${tagUsers}`
            }
            return `${d.properties.point_count}`
          }
        },
        onClick: ({ object }) => this.$_onClickFeature(object),
        onHover: ({ object }) => this.$_onHoverFeature(object),
        onClustered: (data) => this.$_updateClusterInfo(data),
        updateTriggers: {
          getIcon: [this.iconMapping],
        },
      }
      this.myRenderer = rendererFactory.createRenderer(
        force ? [...this.statuses] : this.statuses,
        props
      )
    },

    /**
     * 地物クリック時処理
     * @param {Object} object クリック地物
     */
    $_onClickFeature: function (object) {
      if (this.isCluster(object)) {
        // レイヤーの再描画
        this.$_updateStatusLayer(true)
        this.onClickCluster(object)
      } else {
        // クラスタアイコンではないのでステイタス詳細ダイアログを表示
        this.$_showStatusDialog(object.properties.id)
      }
    },

    /**
     * 地物ホバー時処理
     * @param {Object|undefined} object クリック地物|ホバー解除時はundefined
     */
    $_onHoverFeature: function (object) {
      // 地物にホバーしている場合はマウスカーソルをポインタに変更
      this.map.currentMapComponent.changeCursor(object ? 'pointer' : '')

      this.isClusterHoverd = this.isCluster(object)
      if (this.isClusterHoverd) {
        this.onHoverCluster(object)
      } else if (!this.isPopupHoverd) {
        // クラスタアイコンとポップアップにホバーしていないのでポップアップを非表示
        this.clusters = this.clusters.map((cluster) => ({
          ...cluster,
          showPopup:
            cluster.id === this.hoveredCluster?.id ? false : cluster.showPopup,
        }))
      }
    },

    /**
     * クラスタ組成情報を更新
     * @param {Array.<Object>} data クラスタデータ
     */
    $_updateClusterInfo: function (data) {
      this.clusters = data
        .filter((d) => d.properties.cluster)
        .map((d) => ({
          ...d,
          id: d.id || d.properties.id,
          count: d.properties.point_count,
          showPopup: false,
          fixPopup: this.getFixPopupFromCurrentClusterInfo(d),
        }))
        .sort((a, b) => a.id - b.id)
    },

    /**
     * リストのスクロールバーを先頭に移動する
     */
    $_scrollListToTop: function () {
      const scrollElement = this.$refs['status-list-inner']
      scrollElement && scrollElement.scrollToPosition(0)
    },

    /**
     * ステイタス件数を表示する
     */
    $_showStatusTotalCount: function () {
      // URL作成
      var url = RestApiClient.createApiUrl('status/count')
      var params = url.searchParams
      // 検索条件追加
      this.$_addSearchCondition(params)

      RestApiClient.executeGetApi(url)
        .then((json) => {
          this.statusTotalCount = json.data.count
        })
        .catch((error) => {
          this.handleApiError(error)
        })
    },

    /**
     * URLSearchParamsに検索パラメータを追加する(limit, offsetは含まない)
     * @param {URLSearchParams} params パラメータを追加するURLSearchParams
     */
    $_addSearchCondition: function (params) {
      // ユーザーID
      if (this.currentUserIds.length > 0) {
        params.append('user_id', this.currentUserIds)
      }
      // グループID
      if (this.currentOrganizationIds.length > 0) {
        params.append('organization_id', this.currentOrganizationIds)
      }
      // ステイタスタイプID
      if (this.currentStatusTypeIds.length > 0) {
        params.append('status_type_id', this.currentStatusTypeIds)
      }

      // 検索期間
      var startDate = this.$_createMoment(this.searchPeriod.startDate)
      if (startDate && startDate.isValid()) {
        startDate.set({
          'hour': 0,
          'minute': 0,
          'second': 0,
          'millisecond': 0,
        })
        params.append(
          'from',
          toServerTz(+startDate, DATETIME_FORMAT_MILLISECOND)
        )
      }
      var endDate = this.$_createMoment(this.searchPeriod.endDate)
      if (endDate && endDate.isValid()) {
        endDate.set({
          'hour': 23,
          'minute': 59,
          'second': 59,
          'millisecond': 999,
        })
        params.append('to', toServerTz(+endDate, DATETIME_FORMAT_MILLISECOND))
      }

      // キーワード
      if (this.searchKeyword) {
        // 半角スペース区切りでor検索ができるため、全角スペースを半角スペースに置き換える
        let keyword = this.searchKeyword.replace(/　/g, ' ')
        params.append('keyword', keyword)
      }
    },

    /**
     * ステイタスタイプ選択コンポーネントで検索対象のステイタスタイプの選択が完了した時の処理
     * @param {Array} selectedStatusTypes 選択されたステイタスタイプ情報のリスト
     */
    $_onSelectedStatus: function (selectedStatusTypes) {
      // 選択中のステイタスタイプIDを更新する
      this.currentStatusTypeIds = []
      selectedStatusTypes.forEach((statusType) => {
        this.currentStatusTypeIds.push(statusType.id)
      })

      // ステイタスを再検索する
      this.$_showStatus()
    },

    /**
     * ユーザー選択コンポーネントで検索対象のユーザーが確定した時の処理
     * @param {Array.<Object>} retValue ユーザー/グループID, 名前の配列
     */
    $_fixSelectedUsers: function (retValue) {
      if (!retValue) {
        this.currentUserIds = []
        this.currentOrganizationIds = []
        this.$_showStatus()
        return
      }

      const selectedUserIds = retValue
        .filter((value) => value.type === 'user')
        .map((value) => value.id)
      const selectedOrganizationIds = retValue
        .filter((value) => value.type === 'organization')
        .map((value) => value.id)
      // 変更されていない場合は何もしない
      if (
        _.isEqual(this.currentUserIds, selectedUserIds) &&
        _.isEqual(this.currentOrganizationIds, selectedOrganizationIds)
      ) {
        return
      }
      this.currentUserIds = selectedUserIds
      this.currentOrganizationIds = selectedOrganizationIds
      this.$_showStatus()
    },

    /**
     * 検索対象期間が変更された時の処理
     * @param {string} startDate 開始日文字列(yyyy-mm-dd)
     * @param {string} startTime 開始時刻文字列(hh:mm)
     * @param {string} endDate 終了日文字列(yyyy-mm-dd)
     * @param {string} endTime 終了時刻文字列(hh:mm)
     * @param {string} errorMessage バリデーションエラーメッセージ
     */
    $_changeSearchPeriod: function (
      startDate,
      startTime,
      endDate,
      endTime,
      errorMessage
    ) {
      if (errorMessage) {
        // バリデーションエラーを表示する
        this.$alert.fire({
          icon: 'error',
          title: this.$t('theStatus.message.invalidRegistrationDate'),
          text: errorMessage,
        })
      } else {
        // 指定された期間でステイタスを検索する
        this.searchPeriod.startDate = this.$_parseDate(startDate)
        this.searchPeriod.endDate = this.$_parseDate(endDate)
        this.$_showStatus()
      }
    },

    /**
     * 日付文字列(yyyy-mm-dd)から日付オブジェクトを作成する
     * @param {string} targetDate 対象日付文字列
     * @return {Date} 生成した日付、ただしtargetDateがnullの場合はnullを返却する
     */
    $_parseDate: function (targetDate) {
      return targetDate ? moment(targetDate).toDate() : null
    },

    /**
     * Dateオブジェクトからmomentを生成する
     * @param {Date} dateValue 元の日付
     * @return {moment} moment、ただしdateValueがnullの場合はnull
     */
    $_createMoment: function (dateValue) {
      if (!dateValue) {
        return null
      }
      return moment(dateValue)
    },

    /**
     * キーワード検索実行時処理
     * @param {String} value キーワード
     */
    $_onSearchKeyword: function (value) {
      this.searchKeyword = value
      this.isKeywordChanged && this.$_showStatus()
    },

    /**
     * リロードボタンクリック時処理
     */
    $_onClickReload: function () {
      this.isReloading = true
      this.$_showStatus()
    },

    /**
     * ステイタス詳細ダイアログを表示する
     * @param recordId 表示対象のステイタスレコードのID
     */
    $_showStatusDialog: function (recordId) {
      // ダイアログを表示する
      this.$refs['status-detail'].showModal(recordId)
    },

    /**
     * プレイス詳細ダイアログを表示する
     * @param {Number} recordId 表示対象のプレイスレコードのID
     */
    $_showPlaceDialog: function (recordId) {
      // ダイアログを表示する
      this.$refs['place-detail'].showModal(recordId)
    },

    /**
     * 報告書ページへ遷移する
     * @param {Array.<Number>} placeIds プレイスID配列
     */
    $_showReport: function (placeIds) {
      this.$router.push({
        name: 'report',
        params: {
          defaultPlaceIds: placeIds,
        },
      })
    },

    /**
     * 地図ページへ遷移する
     * @param {Object} params 遷移時に引き渡すパラメータ
     */
    $_showMember: function (params) {
      this.$router.push({
        name: 'member',
        params,
      })
    },

    /**
     * ステイタスカードをクリックした時の処理
     * @param {number} timelineType タイムラインタイプ(使用しない)
     * @param {number} recordId クリックしたカードのレコードID
     */
    $_onClickCardBody: function (timelineType, recordId) {
      if (!this.map) return
      // 地図のフォーカスを選択したデータに設定する
      const bounds = this.$_getSpecificStatusBounds(recordId)
      this.map.fitBounds(bounds)
    },

    /**
     * 特定のステイタスのboundsを取得する
     * @param {Number} id ステイタスID
     * @returns {Object} bounds
     */
    $_getSpecificStatusBounds: function (id) {
      const data = this.statuses.find((m) => m.id === id)
      if (!data) return null
      const coordinates = data.geom.geometry.coordinates
      return {
        sw: coordinates,
        ne: coordinates,
      }
    },

    /**
     * ステイタスカードのタイトルをクリックした時の処理
     * @param {number} timelineType タイムラインタイプ(使用しない)
     * @param {number} recordId クリックしたカードのレコードID
     */
    $_onClickCardTitle: function (timelineType, recordId) {
      // 詳細ダイアログを表示する
      this.$_showStatusDialog(recordId)
    },

    /**
     * プレイス詳細非表示時処理
     * @param {Boolean} isUpdated 表示されていたプレイスが更新された場合はtrue
     */
    $_onHidePlaceDetail: function (isUpdated) {
      if (isUpdated) {
        // 地図の強制再描画
        const deck = this.map.getMapDeckController()
        deck && deck.render(true)
      }
    },

    /**
     * リストビューの表示・非表示を切り替える
     */
    $_toggleListViewShown: function () {
      this.isListViewShown = !this.isListViewShown
    },

    /**
     * 1ページあたりの表示件数が変更された時の処理
     */
    $_onChangeListLimit: function (value) {
      this.listLimit = value
      this.$_showStatus()
    },

    /**
     * モーダル重畳状態変更時処理
     * @param {Boolean} value モーダル重畳状態
     */
    $_onModalOverlayChanged: function (value) {
      this.isModalOverlaid = value
    },

    /**
     * ローディングを表示する
     */
    $_showLoading: function () {
      this.isLoading = true
    },

    /**
     * ローディングを非表示にする
     */
    $_hideLoading: function () {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../assets/scss/parts/container';
@use '../assets/scss/parts/tool-bar';
@use '../assets/scss/parts/title-bar';

$-list-header-height: 0px;
$-list-footer-height: calc(
  #{$pagination-height} + #{$list-footer-padding-top} +
    #{$list-footer-border-width}
);

#the-status {
  width: 100%;
  height: 100%;
}

.container-status {
  ::v-deep .row {
    margin: 0;
  }
}

.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(100% - #{$tool-bar-height});
  margin-right: 0;
}

.view-list {
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: #ffffff;
  transition: 0.3s;
  z-index: 1; // ポップアップより前面に配置
}

.tool-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1; // ポップアップより前面に配置
}

.tool-bar-form {
  width: 100%;
}

.title-bar {
  padding: 0 10px 0 16px;
}

.list-wrapper {
  height: calc(100% - #{$title-bar-height});
  padding: 0 10px 6px 10px;
  flex-grow: 1;
  flex-basis: 0;
}

.list-header {
  height: $-list-header-height;
  display: flex;
  align-items: center;
  margin-bottom: $list-header-margin-bottom;
}

.list-inner {
  height: calc(
    100% - #{$-list-header-height} - #{$list-header-margin-bottom} -
      #{$-list-footer-height}
  );
  overflow-y: scroll;
  @include mixin-scrollbar;
}

.status-detail-content {
  width: 100%;
  height: 230px; // card-checkinのheight 210px + 下部margin 20px
}

.list-footer {
  width: 100%;
  height: $-list-footer-height;
  padding-top: $list-footer-padding-top;
  background-color: #fff;
  border-top: $list-footer-border-width solid #eaecef;
}

.list-limit {
  padding: 0 30px 0 0;
}

.status-pagination {
  @include mixin-pagination;
}

.view-map {
  display: -webkit-box !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  height: 100%;
}

.list-tab {
  position: absolute;
  left: 0;
  top: 16px;
}

#status-map-control {
  ::v-deep .control-wrapper {
    &.left-top-wrapper,
    &.left-bottom-wrapper {
      padding-left: 40px;
    }

    .map-control-ui {
      pointer-events: auto;
    }
  }
}
</style>
